import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './CustomFalseCeiling.module.scss';
import { FalseCeilingLoopingLayout } from './CustomFalseCeilingConstants';
import TabViewSection from "./CustomTabViewSection";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import CustomFalseCeilingLegends from "./CustomFalseCeilingLegends";

const CustomFalseCeilingLoopingLayout = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);


  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  const loopedItemList = (items: any) => {
    const list = items?.map((e) => {
      let matchedObject = updatedValues?.loopedDetails.find(obj => obj.key === e);
      return matchedObject ? matchedObject.caption : null;
    })?.join(', ')

    return list
  }

  return (
    <section className={style.ceiling_looping_section}>
      <h4 className="section_heading">6. Looping Layout</h4>
      <div className={style.ceiling_looping_container}>
        <div className={style.false_ceiling_overview}>
          <div className={style.leftSection_tab}>
            <div className={style.sub_tab_section}>
              <h4 className="sub_tab_heading">Legend</h4>
              <div className={style.sub_tab_options}>
                <CustomFalseCeilingLegends />
              </div>
            </div>
          </div>
        </div>
        <div className={style.reflected_plan}>
          <h4 className="sub_tab_heading">Electrical Looping Layout</h4>
          {
            pageDetails.images?.[0]?.imageUrl ? <div className={style.image_view_container}><img crossOrigin="anonymous" alt={pageDetails?.images?.[0]?.name} src={pageDetails.images?.[0]?.imageUrl} className="image-view" /></div> :
              <div className={style.canvas_view_description}>
                <h4 className={style.canvas_view_heading}>Reflected Ceiling Plan of False Ceiling showing Lights, Fan, AC, AC Cutouts seen</h4>
                <div className={style.canvas_view_details}>
                  <p className={style.canvas_view_details_head}>Mandatory Details :</p>
                  <ul className={style.canvas_view_details_listing}>
                    <li>Overall room dimensions in plan</li>
                    <li>Primary and Secondary looping for all light fixtures and fans</li>
                    <li>Switch box and module details (creation of point / addition of point)</li>
                  </ul>
                </div>
              </div>
          }
        </div>
      </div>
      {
        updatedValues?.loopedDetails?.length ? <div className={style.looping_layout_details}>
          <div className={style.three_col_tab}>
            <h4>Light Details</h4>
            <h4>Looped to Point</h4>
            <h4>Light Type</h4>
          </div>
          {
            updatedValues?.loopedDetails?.map((e, id) => {
              if (e?.loopedTo?.length && e?.viewLayer === "FALSE_CEILING") {
                return (
                  <div className={style.three_col_tab} key={id}>
                    <p>{e.caption}</p>
                    <p>{loopedItemList(e?.loopedTo)}</p>
                    <p>{e.lightType}</p>
                  </div>
                )
              }
            })
          }
        </div> : ''
      }
    </section>
  )
}

export default CustomFalseCeilingLoopingLayout;